import Phaser from 'phaser';
import { GAME_CONFIG } from '../config/gameConfig';

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload(): void {
    // プログレスバーの作成
    this.createProgressBar();

    // アイテム画像の読み込み（1〜137）
    for (let i = 1; i <= GAME_CONFIG.TOTAL_ITEM_TYPES; i++) {
      this.load.image(`item_${i}`, `assets/images/item/${i}.png`);
    }

    // サウンドボタン
    this.load.image('sound_on', 'assets/images/sound_on.png');
    this.load.image('sound_off', 'assets/images/sound_off.png');

    // タイトルロゴ
    this.load.image('title_logo', 'assets/images/title_logo.png');

    // 正解時のパーティクルアニメーション（Lottie）
    this.load.json('particle1', 'assets/animations/particle1.json');
    this.load.json('particle2', 'assets/animations/particle2.json');

    // サウンド
    this.load.audio('bgm', 'assets/sounds/bgm.mp3');
    this.load.audio('button', 'assets/sounds/button.mp3');
    this.load.audio('game_over', 'assets/sounds/game_over.mp3');
    this.load.audio('good', 'assets/sounds/good.mp3');
    this.load.audio('miss', 'assets/sounds/miss.mp3');
    this.load.audio('clear', 'assets/sounds/clear.mp3');
  }

  private createProgressBar(): void {
    const { WIDTH, HEIGHT, COLORS } = GAME_CONFIG;
    const centerX = WIDTH / 2;
    const centerY = HEIGHT / 2;

    // 背景（バウハウス：白）
    const bg = this.add.graphics();
    bg.fillStyle(COLORS.WHITE, 1);
    bg.fillRect(0, 0, WIDTH, HEIGHT);

    // ローディングテキスト
    const loadingText = this.add.text(centerX, centerY - 80, 'ローディング中...', {
      fontFamily: GAME_CONFIG.FONTS.DEFAULT,
      fontSize: `${GAME_CONFIG.FONTS.LARGE_SIZE}px`,
      color: '#000000',
      fontStyle: 'bold',
    });
    loadingText.setOrigin(0.5);

    // プログレスバーの枠（バウハウス：黒枠）
    const progressBox = this.add.graphics();
    progressBox.fillStyle(0xffffff, 1);
    progressBox.fillRect(centerX - 200, centerY - 20, 400, 40);
    progressBox.lineStyle(2, 0x000000, 1);
    progressBox.strokeRect(centerX - 200, centerY - 20, 400, 40);

    // プログレスバー
    const progressBar = this.add.graphics();

    // パーセントテキスト
    const percentText = this.add.text(centerX, centerY + 60, '0%', {
      fontFamily: GAME_CONFIG.FONTS.DEFAULT,
      fontSize: `${GAME_CONFIG.FONTS.MEDIUM_SIZE}px`,
      color: '#000000',
      fontStyle: 'bold',
    });
    percentText.setOrigin(0.5);

    // ローディング進捗イベント
    this.load.on('progress', (value: number) => {
      progressBar.clear();
      progressBar.fillStyle(COLORS.PRIMARY, 1);
      progressBar.fillRect(
        centerX - 195,
        centerY - 15,
        390 * value,
        30
      );
      percentText.setText(`${Math.floor(value * 100)}%`);
    });

    // ローディング完了イベント
    this.load.on('complete', () => {
      progressBar.destroy();
      progressBox.destroy();
      loadingText.destroy();
      percentText.destroy();
    });
  }

  create(): void {
    // タイトルシーンへ遷移
    this.scene.start('TitleScene');
  }
}
